<template>
  <svg :class="[name]" width="242px" height="53px">
    <polygon
      v-for="(line, index) in waves"
      :key="index"
      :points="line"
      fill="currentColor"
      :opacity="Math.random() * (1 - 0.2) + 0.2"
    ></polygon>
  </svg>
</template>

<script>
export default {
  data() {
    return {
      name: 'a-svg-waveform',
      show: false,
      updateInterval: 500,
      waves: [
        '93 34.5 95 34.5 95 19.5 93 19.5',
        '101 40.5 103 40.5 103 12.5 101 12.5',
        '111 45.5 113 45.5 113 8.5 111 8.5',
        '120 53.5 122 53.5 122 0.5 120 0.5',
        '46 36.5 48 36.5 48 17.5 46 17.5',
        '55 39.5 57 39.5 57 13.5 55 13.5',
        '65 45.5 67 45.5 67 7.5 65 7.5',
        '74 39.5 76 39.5 76 13.5 74 13.5',
        '83 36.5 85 36.5 85 17.5 83 17.5',
        '9 32.5 11 32.5 11 21.5 9 21.5',
        '18 40.5 20 40.5 20 12.5 18 12.5',
        '28 33.5 30 33.5 30 19.5 28 19.5',
        '37 32.5 39 32.5 39 21.5 37 21.5',
        '0 28.5 2 28.5 2 24.5 0 24.5',
        '147 34.5 149 34.5 149 19.5 147 19.5',
        '139 40.5 141 40.5 141 12.5 139 12.5',
        '129 45.5 131 45.5 131 8.5 129 8.5',
        '194 36.5 196 36.5 196 17.5 194 17.5',
        '185 39.5 187 39.5 187 13.5 185 13.5',
        '175 45.5 177 45.5 177 7.5 175 7.5',
        '166 39.5 168 39.5 168 13.5 166 13.5',
        '157 36.5 159 36.5 159 17.5 157 17.5',
        '231 32.5 233 32.5 233 21.5 231 21.5',
        '222 40.5 224 40.5 224 12.5 222 12.5',
        '212 33.5 214 33.5 214 19.5 212 19.5',
        '203 32.5 205 32.5 205 21.5 203 21.5',
        '240 28.5 242 28.5 242 24.5 240 24.5',
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
